import { Grid, Header, Icon, Button, Label } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import {
  getLinkTreeStatus,
  getLinkTreeTypeMeta,
  getUpdatedAtColor,
} from "../../utils/linktreeHelper";

const formatDateForView = (isoDate) => {
  if (!isoDate) return "";
  return isoDate.split("T")[0].split("-").reverse().join(".");
};
const LinktreeListViewItem = ({
  id,
  title,
  slug,
  type,
  isActive,
  updatedAt,
  createdAt,
  onClickEdit,
}) => {
  const { t } = useTranslation();

  const status = getLinkTreeStatus(isActive);
  const statusKey = status.key;
  const typeMeta = getLinkTreeTypeMeta(type);
  const color = getUpdatedAtColor(updatedAt);

  const publicUrl = `https://bhmm.de/l/${slug}`;

  return (
    <Grid
      columns="equal"
      stackable
      verticalAlign="middle"
      key={`linktree-list-view-item-${id}`}
    >
      <Grid.Column textAlign="left">
        <Header as="h2" style={{ marginBottom: "0.5rem" }}>
          {title}
        </Header>
        <Label size="medium" color={typeMeta.color}>
          <Icon name={typeMeta.icon} />
          {typeMeta.label}
        </Label>
        <Label size="medium" color={status.color}>
          <Icon
            name={
              statusKey === "published"
                ? "check circle"
                : statusKey === "draft"
                  ? "edit outline"
                  : "question circle"
            }
          />
          {status.label}
        </Label>
      </Grid.Column>

      <Grid.Column>
        <p style={{ display: "flex", gap: "0.5rem" }}>
          <Icon name="linkify" color="blue" />
          <a
            href={publicUrl}
            title={publicUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              maxWidth: "100%",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              direction: "rtl",
              textAlign: "left",
            }}
          >
            {publicUrl}
          </a>
        </p>
      </Grid.Column>

      <Grid.Column>
        <p>
          <Icon name="plus square" color={color} />
          {t('label-createdAt')} {formatDateForView(createdAt)}
          <br />
          <Icon name="refresh" color={color} />
          {t('label-modifiedAt')} {formatDateForView(updatedAt)}
        </p>
      </Grid.Column>

      <Grid.Column>
        <Button.Group floated="right">
          <Button
            primary
            size="medium"
            onClick={() => onClickEdit({ id, title })}q
          >
            <Icon name="edit" />
            {t("button-detail")}
          </Button>
        </Button.Group>
      </Grid.Column>
    </Grid>
  );
};

export default LinktreeListViewItem;
